import { Img, Picture } from '@xo-union/tk-component-picture';
import React, { type FC, type SyntheticEvent, useCallback } from 'react';
import { CONSTANTS } from '../constants';
import Styles from './styles.scss';

export interface ImageWrapProps {
	index: number;
	onError: (imageReference: SyntheticEvent<HTMLImageElement, Event>) => void;
	onLoad: () => void;
	sourceId: string;
	isDesktop?: boolean;
}

const ImageWrap: FC<ImageWrapProps> = (props) => {
	const { index, onError, onLoad, sourceId, isDesktop } = props;
	const imageComplete = useCallback(
		(node: HTMLImageElement | null) => {
			if (node?.complete) {
				onLoad();
			}
		},
		[onLoad],
	);

	return (
		<Picture lazy id={sourceId}>
			<Img
				height={
					isDesktop
						? CONSTANTS.desktop.imageHeight
						: CONSTANTS.mobile.imageHeight
				}
				width={
					isDesktop ? CONSTANTS.desktop.imageWidth : CONSTANTS.mobile.imageWidth
				}
				className={Styles.image}
				alt={`User review media ${index + 1}`}
				elementProps={{
					onError,
					onLoad,
					ref: imageComplete,
					loading: 'lazy',
				}}
			/>
		</Picture>
	);
};

export { ImageWrap };
